import axios from 'axios';
import BillingInformationModel from '../../components/payments/billing-information.model.js';

function logError(error) {
	throw error;
}

class UserAccountService {
	updateProfile(props) {
		return axios
			.put(`${process.env.REACT_APP_API_URL}/api/account/${props.id}`, {
				...props,
			})
			.then(res => res)
			.catch(logError);
	}

	changePassword({ currentPassword, newPassword }) {
		return axios
			.put(
				`${
					process.env.REACT_APP_API_URL
				}/api/account/pwd/change?currentPassword=${currentPassword}&newPassword=${newPassword}`,
				{},
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
				},
			)
			.then(res => res)
			.catch(logError);
	}

	getSolverGroups({ lang = 'en_GB', size = 100 } = {}) {
		return axios.get(`${process.env.REACT_APP_API_URL}/api/account/solver`,
			{ params: { members: true, lang, size } })
			.then(({ data }) => data.content)
			.catch(logError);
	}

	updateSolverGroup({
		groupName, name, avatar, challengeAreas, job,
	}) {
		return axios.put(`${process.env.REACT_APP_API_URL}/api/account/solver/${groupName}`,
			{
				name,
				avatar,
				challengeAreas,
				job,
			})
			.then(({ data }) => data);
	}

	getSeekerGroups({ lang = 'en_GB', size = 100 } = {}) {
		return axios.get(`${process.env.REACT_APP_API_URL}/api/account/seeker`,
			{ params: { members: true, lang, size } })
			.then(({ data }) => data.content)
			.catch(logError);
	}

	updateSeekerGroup({
		groupName, name, avatar, challengeAreas, job,
	}) {
		return axios.put(`${process.env.REACT_APP_API_URL}/api/account/seeker/${groupName}`,
			{
				name,
				avatar,
				challengeAreas,
				job,
			})
			.then(({ data }) => data)
			.catch(logError);
	}

	getAllMembersByGroupId({ groupName, type } = {}) {
		return axios.get(`${process.env.REACT_APP_API_URL}/api/account/${type}/${groupName}/member`)
			.then(res => res)
			.catch(logError);
	}

	checkIfEmailIsAvailable({ type, email }) {
		return axios
			.post(`${process.env.REACT_APP_API_URL}/api/account/${type}/group/invite?email=${email}`)
			.then(res => res)
			.catch(logError);
	}

	inviteMemberToGroup({ type, groupName, emails }) {
		return axios
			.post(`${process.env.REACT_APP_API_URL}/api/account/${type}/member/${groupName}`,
				{ emails })
			.then(({ data }) => data.content)
			.catch(logError);
	}


	acceptedInviteToGroup({ token, type }) {
		return axios
			.put(`${process.env.REACT_APP_API_URL}/api/account/${type}/member?token=${token}`)
			.then(res => res)
			.catch(logError);
	}

	deleteMemberFromGroup({ type, groupName, email }) {
		return axios
			.delete(`${process.env.REACT_APP_API_URL}/api/account/${type}/member/${groupName}?email=${email}`)
			.then(res => res)
			.catch(logError);
	}

	acceptTermsConditions() {
		return axios
			.put(`${process.env.REACT_APP_API_URL}/api/account/terms_conditions`)
			.then(res => res)
			.catch(logError);
	}

	getBillingInfo({ lang = 'en_GB' } = {}) {
		return axios.get(`${process.env.REACT_APP_API_URL}/api/invoice/billingClient`,
			{ params: { lang } })
			.then(({ data }) => data && new BillingInformationModel(data.client))
			.catch(logError);
	}

	getCountries({ page = 0, size = 10, lang = 'en_GB' } = {}) {
		return axios
			.get(
				`${process.env.REACT_APP_API_URL}/api/invoice/country`,
				{ params: { lang, page, size } },
			)
			.then(res => ({
				first: res.data.first,
				last: res.data.last,
				areas: res.data.content,
			}));
	}

	searchCountry({
		page = 0, size = 10, searchTerm = '', lang = 'en_GB',
	} = {}) {
		return axios
			.get(
				`${process.env.REACT_APP_API_URL}/api/invoice/country/searchauto`,
				{
					params: {
						text: searchTerm, page, size, lang,
					},
				},
			)
			.then(res => res.data);
	}

	updateBillingInfo({
		id, name, address, city, countryId, postalCode, fiscalId,
	}) {
		if (id) {
			return axios.put(`${process.env.REACT_APP_API_URL}/api/invoice/billingClient`,
				{
					client: {
						id,
						name,
						address,
						city,
						countryId,
						fiscal_id: fiscalId,
						postal_code: postalCode,
					},
				})
				.then(({ data }) => data)
				.catch(logError);
		}
		return axios.post(`${process.env.REACT_APP_API_URL}/api/invoice/billingClient`,
			{
				client: {
					name,
					address,
					city,
					countryId,
					fiscal_id: fiscalId,
					postal_code: postalCode,
				},
			})
			.then(({ data }) => data)
			.catch(logError);
	}

	seekerHasChallenges(groupName) {
		return axios
			.get(`${process.env.REACT_APP_API_URL}/api/account/seeker/${groupName}/has-challenge`)
			.then(res => res.data)
			.catch(logError);
	}

	solverHasSolutions(groupName) {
		return axios
			.get(`${process.env.REACT_APP_API_URL}/api/account/solver/${groupName}/has-solution`)
			.then(res => res.data)
			.catch(logError);
	}

	deleteAccount() {
		return axios
			.delete(`${process.env.REACT_APP_API_URL}/api/account`)
			.then(res => res)
			.catch(logError);
	}

	deleteSolver({ solverName }) {
		return axios
			.delete(`${process.env.REACT_APP_API_URL}/api/account/solver/${solverName}`)
			.then(res => res)
			.catch(logError);
	}

	deleteSeeker({ seekerName }) {
		return axios
			.delete(`${process.env.REACT_APP_API_URL}/api/account/seeker/${seekerName}`)
			.then(res => res)
			.catch(logError);
	}
}

export default new UserAccountService();
